// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HeadToTheAppDialog_overlay__gQS2I","qr":"HeadToTheAppDialog_qr__JJLzO"};